import * as yup from 'yup';
import type { BannerFormData } from '../components/CreateBannerModal/CreateBannerModal';

export const bannerFormSchema: yup.ObjectSchema<BannerFormData> = yup.object({
  title: yup.string().required('Название обязательно'),
  link: yup
    .string()
    .optional()
    .test(
      'is-valid-link',
      'Ссылка должна начинаться с https:// или быть ссылкой на раздел приложения',
      (value) => {
        const link = value?.trim();
        if (!link) return true;
        if (link.startsWith('/')) return true;
        try {
          const url = new URL(link);
          return url.protocol === 'https:' || url.protocol === 'http:';
        } catch {
          return false;
        }
      },
    ),
  image: yup.mixed<File | { id: number; url: string }>()
    .required('Изображение баннера обязательно')
    .test('is-valid', 'Изображение обязательно', value => {
      return value !== undefined && value !== null;
    }),
  storyImages: yup.array()
    .of(yup.mixed<File | { id: number; url: string }>().required())
    .optional(),
});